import type { CropOperation, CropPresentation } from './types';

export const DEFAULT_CROP_PRESENTATION: CropPresentation = {
  borderColor: '#fff',
  borderWidth: 2,
  checkerboardDark: '#e5e5e5',
  checkerboardLight: '#fff',
  checkerboardSize: 24,
  gridColor: '#fff',
  gridWidth: 1,
  handleFill: '#fff',
  handleSize: 10,
  previewPadding: 3,
  shadowColor: '#000',
  shadowOpacity: 0.5,
};

export const getCropCursor = (operation: CropOperation): CSSStyleDeclaration['cursor'] => {
  switch (operation) {
    case 'move':
      return 'move';
    case 'resize-n':
    case 'resize-s':
      return 'ns-resize';
    case 'resize-e':
    case 'resize-w':
      return 'ew-resize';
    case 'resize-ne':
    case 'resize-sw':
      return 'nesw-resize';
    case 'resize-nw':
    case 'resize-se':
      return 'nwse-resize';
    default:
      return 'default';
  }
};
